module.exports = __webpack_public_path__ + "static/media/manual_end.dcbb8918.png";